// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Bj45S","colBig":"styles_colBig__3tqAw","colSmall":"styles_colSmall__2iA6-","shopifyNameWrapper":"styles_shopifyNameWrapper__28Jzr"};